import SubMenu from 'theme/sub-menu';
import translations from 'translations';
import { useSelector, useDispatch } from 'react-redux';
import { useRouter } from 'next/router';
import { changeDataTypeFilter, resetChanged } from 'redux-api/action/filters';
import selectFilters from 'redux-api/reselect/filters';
import selectProfile from 'redux-api/reselect/profile';
import { backgroundColor } from 'styled-system';

function AnalyticsSubMenu({ activeKey }) {
  const dispatch = useDispatch();
  const { languageCode } = useSelector((state) => state.config);
  const { push, query } = useRouter();
  const { dataType, compare, dateRange, dateFrom, dateTo, filters, terms, filtersData, termsData } =
    useSelector(selectFilters);

  const {
    payload: { company, analytics_type, hasPROPlan },
  } = useSelector(selectProfile);

  const handleDataTypeChange = (dataType) => () => {
    dispatch(changeDataTypeFilter(dataType));
    dispatch(resetChanged());

    const newQuery = {
      compare: encodeURI(compare),
      dataType: encodeURI(dataType),
      dateRange: encodeURI(dateRange),
      dateFrom: encodeURI(dateFrom),
      dateTo: encodeURI(dateTo),
      filters: encodeURI(filters),
      terms: encodeURI(terms),
      filtersData: encodeURI(filtersData),
      termsData: encodeURI(termsData),
    };

    push({
      pathname: '/analytics',
      query: newQuery,
    });
  };

  const options = [
    {
      key: 'panoramic',
      title: analytics_type?.match(/split/i)
        ? translations[languageCode].trend
        : translations[languageCode].revenues,
      onClick: handleDataTypeChange(
        analytics_type?.match(/split/i) ? 'temporary_data' : 'aggregated_data',
      ),
      color: 'primary_300',
    },
    {
      key: 'usage',
      title: translations[languageCode].usage,
      onClick: handleDataTypeChange('usage_data'),
    },
    {
      key: 'data-stores',
      title: translations[languageCode]['Data & Stores'],
      href: '/analytics/data-stores',
    },
  ];

  if (analytics_type?.match(/split/i)) {
    options.splice(1, 0, {
      key: 'confirmed',
      title: translations[languageCode].realdata,
      onClick: handleDataTypeChange('real_data'),
      color: 'primary_300',
    });
  }

  if (company && company?.code === 'SL_US' && !hasPROPlan)
    options.push({
      key: 'upgradeToPro',
      title: translations[languageCode].upgradeToPro,
      href: 'https://www.streetlib.com/pricing/',
      color: 'orange_400',
    });

  return <SubMenu activeKey={dataType !== 'usage_data' ? activeKey : 'usage'} options={options} />;
}

export default AnalyticsSubMenu;
